import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import TokenManager from '../utils/tokenManager';
import { useUser } from '../hooks/useUser';
import './User.scss';

const User: React.FC = () => {
  const { data: user, isLoading, error } = useUser();
  const tokenManager = TokenManager.getInstance();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = !!user;

  const handleSignIn = () => {
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;
    const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);
    const cognitoUrl = process.env.REACT_APP_OAUTH_ISSUER;
    
    if (clientId && cognitoUrl) {
      const loginUrl = `${cognitoUrl}/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid+profile+email`;
      window.location.href = loginUrl;
    }
  };

  const handleLogout = async () => {
    await tokenManager.logout();
    setIsMenuOpen(false);
    // TokenManager will handle the redirect to Cognito logout
  };

  const handleEdit = () => {
    window.location.href = '/edit-user';
    setIsMenuOpen(false);
  };

  const handleLogin = () => {
    handleSignIn();
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('.user__menu-container')) {
        setIsMenuOpen(false);
      }
    };
    
    if (isMenuOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isMenuOpen]);

  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (error) {
    console.log('User not authenticated');
    tokenManager.clearTokens();
  }

  return (
    <div className="user__menu-container">
      <button 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className={`user__button ${isAuthenticated ? 'user__button--authenticated' : 'user__button--unauthenticated'}`}
      >
        <FontAwesomeIcon icon={faUser} />
      </button>
      
      {isMenuOpen && (
        <div className="user__menu">
          {isAuthenticated ? (
            <>
              <button onClick={handleEdit} className="user__menu-item">
                Profile
              </button>
              <button onClick={handleLogout} className="user__menu-item">
                Log out
              </button>
            </>
          ) : (
            <button onClick={handleLogin} className="user__menu-item">
              Login...
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default User;